import { Td } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import type { QuoteMarketplaceTheme } from '../../hooks';

export const STICKY_LABEL_WIDTH = 250;
export const STICKY_REQUESTED_WIDTH = 120;
export const STICKY_SELECTED_LEFT = STICKY_LABEL_WIDTH + STICKY_REQUESTED_WIDTH;

interface CarrierCellProps {
  isSelected: boolean;
  theme: QuoteMarketplaceTheme;
  children?: ReactNode;
  textAlign?: 'left' | 'center' | 'right';
  py?: number;
  minW?: string;
  verticalAlign?: 'top' | 'middle' | 'bottom';
  fontWeight?: string;
  fontSize?: string;
  isSticky?: boolean;
}

const toColorVar = (color: string) =>
  `var(--chakra-colors-${color.replace('.', '-')})`;

const selectedBorderStyles = (borderColorVar: string) => ({
  content: '""',
  position: 'absolute',
  top: '-1px',
  bottom: '-1px',
  width: '2px',
  bg: borderColorVar,
  zIndex: 10,
  pointerEvents: 'none',
});

export const CarrierCell = ({
  isSelected,
  theme,
  children,
  textAlign = 'center',
  py = 3,
  minW,
  verticalAlign,
  fontWeight,
  fontSize,
  isSticky = false,
}: CarrierCellProps) => {
  const borderColorVar = toColorVar(theme.selectedBorderColor);

  return (
    <Td
      borderColor={theme.borderColor}
      textAlign={textAlign}
      py={py}
      minW={minW}
      verticalAlign={verticalAlign}
      fontWeight={fontWeight}
      fontSize={fontSize}
      bg={isSelected ? theme.selectedCellBg : undefined}
      overflow={isSelected ? 'visible' : undefined}
      position={isSticky ? 'sticky' : isSelected ? 'relative' : undefined}
      left={isSticky ? `${STICKY_SELECTED_LEFT}px` : undefined}
      zIndex={isSticky ? 2 : isSelected ? 1 : undefined}
      _before={
        isSelected
          ? { ...selectedBorderStyles(borderColorVar), left: 0 }
          : undefined
      }
      _after={
        isSelected
          ? { ...selectedBorderStyles(borderColorVar), right: 0 }
          : undefined
      }
    >
      {children}
    </Td>
  );
};
